import { TopStatisticsProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { getDroplink } from 'src/shared/param-utils';
import { TOP_STATISTICS_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C50TopStatisticsProps } from './C50TopStatistics.types';

export function CreateTopStatisticsModel(props?: C50TopStatisticsProps): TopStatisticsProps {
  const { fields, params, rendering } = props || {};

  type t = TopStatisticsProps;

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignments: getDroplink<t['contentAlignments']>(params?.ContentAlignments, 'center'),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CtaAlignment, 'center'),
    numberOfColumns: getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '4'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.Cta),
    children: rendering && (
      <Placeholder
        name={`${TOP_STATISTICS_CONTAINER}-${params?.DynamicPlaceholderId}`}
        rendering={rendering}
      />
    ),
  };
}
